var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasErrors)?_c('div',{staticClass:"TRC-ValidationErrors"},[_c('ul',[_vm._l((_vm.errors),function(error){return _vm._l((error),function(errorText){return _c('li',{key:errorText,staticClass:"TRC-ValidationErrors__Error"},[_vm._v("\n                "+_vm._s(errorText)+"\n            ")])})})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }